// src/pages/ParasutCallback.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { exchangeCodeForToken } from '../services/parasutApi';

const ParasutCallback = () => {
  const [code, setCode] = useState('');
  const [durum, setDurum] = useState('');
  const navigate = useNavigate();

  const handleTokenAl = async () => {
    if (!code) return setDurum('❗ Lütfen kod girin.');

    try {
      const sonuc = await exchangeCodeForToken(code);
      setDurum(`✅ Token başarıyla alındı. Şirket ID: ${sonuc.company_id}`);
      
      // Girişten sonra sistem yönlendirme
      setTimeout(() => navigate('/'), 2000);
    } catch (error) {
      setDurum('❌ Token alınırken hata oluştu.');
    }
  };

  return (
    <div className="max-w-xl mx-auto mt-10 p-6 bg-white rounded shadow">
      <h2 className="text-xl font-semibold mb-4">🔐 Paraşüt Erişim Kodu</h2>
      <p className="mb-2 text-sm text-gray-600">
        Paraşüt entegrasyonu için aşağıdaki adımları takip et:
      </p>
      <ol className="text-sm list-decimal ml-5 mb-4">
        <li>Bu bağlantıyı aç: <br />
          <a
            href="https://api.parasut.com/oauth/authorize?client_id=6cSLeWPuVlyOrjLBbr0bWf39x0g09_Kzus_fyluYeAI&redirect_uri=urn:ietf:wg:oauth:2.0:oob&response_type=code"
            target="_blank" rel="noreferrer" className="text-blue-600 underline"
          >
            Paraşüt Yetkilendirme Linki
          </a>
        </li>
        <li>Giriş yap ve sana verilen kodu aşağıya yapıştır.</li>
        <li>“Token Al” butonuna bas.</li>
      </ol>

      <input
        type="text"
        placeholder="🔑 Authorization Code"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        className="w-full px-4 py-2 border rounded mb-4"
      />
      <button
        onClick={handleTokenAl}
        className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        🔐 Token Al
      </button>

      {durum && <p className="mt-4 font-medium">{durum}</p>}
    </div>
  );
};

export default ParasutCallback;
